// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"ce0f1c83","170":"78f73420","338":"91e00b44","544":"72430ae3","624":"78141642","670":"8ad25298"}[chunkId] + ".chunk.js";
};